import logger from '../../../services/logging/logging-service';
import { doQuery, isGenericError, isGraphQlError } from '../../../services/graphql';
import { getFailureAction } from '../../utils/get-failure-action';
import { parseErrorsGraphQL, parseDataParsely } from '../../utils/parsers';
import { authStore } from '../../../global-store/subjects/auth';
import { getParselyUuid } from '../../utils/get-parsely-uuid';

export const doWidgetQuery = ({ widget, widgetId, actions }) => {
  const auth = authStore.getValue();
  const commonVariables = {
    token: auth.userToken,
    widgetId,
    parselyUUID: getParselyUuid(),
  };
  const dataParser = (dataToParse) => parseDataParsely({ data: dataToParse, widgetId });
  doQuery({
    query: widget.services.query,
    variables: commonVariables,
    onStart: actions?.setQueryStart,
    onSuccess: (data) => {
      const parsedData = dataParser(data);
      actions?.setQuerySuccess(parsedData);
    },
    onFailure: (error, type) => {
      if (isGraphQlError(type)) {
        const errorObj = parseErrorsGraphQL(error);
        const failureAction = getFailureAction(actions, auth);
        const queryFailureAction = failureAction(errorObj).query;
        queryFailureAction(errorObj);
        logger.warn(`[${widget.name}] [doQuery() AppSync errors]`, error);
      }
      if (isGenericError(type)) {
        actions?.setQueryFailureGeneric(error);
        logger.warn(`[${widget.name}] [doQuery() generic error]`, error);
      }
    },
  });
};
